import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import AvailableTranslationCacheName from "../../utils/AvailableTranslationCacheName";
import { refuseTranslationReview } from "../../api/refuseTranslationReview";

export function useRefuseTranslationReview(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refuseTranslationReview,
    onSuccess: () => {
      toast.success("Translation review has been refused");
      queryClient.invalidateQueries(AvailableTranslationCacheName.getAvailableTranslation());

      if (onSuccessCallback) {
        onSuccessCallback();
      }
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
